import {useEffect} from "react";

/**
 * Sets the browser tab title on the client. Needed because route `meta`
 * exports only apply in the standalone router — when these pages render as a
 * federated remote inside the main app there is no route module, so the title
 * must be set imperatively.
 */
export function useDocumentTitle(title: string): void {
    useEffect(() => {
        document.title = title;
    }, [title]);
}
